angular.module('unergie.main')
.controller('newPdlCtrl', ($q, $rootScope, $scope, $state, $stateParams, $filter, ReferencesService, ApiUser, DataAccess, AlertManager, CommonRegex, OrganizationService,
    ErrorCatcher, ModalService, BoFeaturesService) => {
    // PRELOAD filter
    $filter('contractStatus')(0)

    $scope.handleServiceOrder = false

    $scope.nameRegex = CommonRegex.fullname
    $scope.phoneRegex = CommonRegex.phone.french

    $scope.prmCategories = [
        { value: 'EP', label: 'Éclairage public ou assimilé' },
        { value: 'Batiment', label: 'Bâtiment' },
    ]

    $scope.phases = [
        { value: 'MONOPHASE', label: 'Monophasé' },
        { value: 'TRIPHASE', label: 'Triphasé' },
    ]
    $scope.id_p_calendars = ['BASE', 'HPHC', 'LU']

    $scope.max_powers = []
    for (let pow = 0.1; pow <= 36; pow = Number((pow + 0.1).toFixed(1))) {
        $scope.max_powers.push({ label: `${pow}kVA`, value: pow })
    }

    $scope.routingTariffs = ['BTINFCUST', 'BTINFLU', 'BTINFLUSC', 'BTINFMUDT']
    $scope.routingTariffsC4 = ['BTSUPCU4', 'BTSUPLU4']
    $scope.routingTariffsC2C3 = ['HTACU5', 'HTALU5']
    $scope.prmOk = undefined

    $scope.recap = {}

    $scope.contact = {}

    $scope.showTools = !BoFeaturesService.get('isEnvProd')

    $scope.managedAccount = undefined
    $scope.chosenManagedAccount = undefined

    OrganizationService.getServiceOrderOrgz().then((serviceOrderOrgz) => {
        $scope.serviceOrderOrgz = serviceOrderOrgz
    })

    $scope.seachAccount = ''
    $scope.selectAccount = (acc) => {
        $scope.managedAccount = acc
    }

    $scope.searchCategory = ''
    $scope.selectCategory = (cat) => {
        return DataAccess.updateProDraft({ id: $scope.draft.id }, { id_category: cat.id }).$promise.then(() => {
            $scope.draft.id_category = cat.id
            $scope.searchCategory = _.find($scope.categories, { id: $scope.draft.id_category }).name
            if ($scope.draft.id_prm) {
                $scope.fetchPrm()
            }
        })
        .catch(ErrorCatcher)
    }

    $scope.chooseManagedAccount = () => {
        return DataAccess.updateProDraft({ id: $scope.draft.id }, { id_account: $scope.managedAccount.id_account }).$promise.then(() => {
            $scope.chosenManagedAccount = $scope.managedAccount
            if ($scope.chosenManagedAccount) {
                $scope.handleServiceOrder = $scope.serviceOrderOrgz.includes($scope.chosenManagedAccount.organization)
                $scope.refresh()
                $scope.loadContacts()
            }
        })
        .catch(ErrorCatcher)
    }

    $scope.isActive = (state) => $state.is(state)

    $scope.draft = {
        id_prm: undefined,
    }

    $rootScope.$on('prmSelected', (e, idPrm) => {
        $scope.draft.id_prm = idPrm
        $scope.prmChanged()
    })

    $scope.prmInputClass = function () {
        if ($scope.prmOk === undefined) {
            return ''
        } else if ($scope.prmOk) { return 'has-success' } return 'has-error'
    }

    // DATE FIELD
    $scope.desired_mes_date = moment().format('DDMMYYYY')

    $scope.updateDateTemplate = () => {
        $scope.draft.desired_mes_date = moment($scope.desired_mes_date, 'DDMMYYYY').toDate()
    }

    // EXISTING CONTACTS
    $scope.loadContacts = function () {
        if (!$scope.existingContacts) {
            DataAccess.getAdditionalContacts({ type: 'TECHNICAL', id_account: $scope.chosenManagedAccount.id_account }).$promise.then((contacts) => {
                $scope.existingContacts = contacts
            }).catch(ErrorCatcher)
        }
        if ($scope.handleServiceOrder && !$scope.existingRequester) {
            DataAccess.getAdditionalContacts({ type: 'REQUESTER_COMMISSION', id_account: $scope.chosenManagedAccount.id_account }).$promise.then((contacts) => {
                $scope.existingRequester = contacts
            }).catch(ErrorCatcher)
        }
    }

    $scope.updateContact = function (contact) {
        $scope.contact = _.pick(contact, ['civ', 'sn', 'givenname', 'phone', 'email'])
    }

    $scope.updateRequester = function (requester) {
        $scope.requester = _.pick(requester, ['civ', 'sn', 'givenname'])
    }

    // DRAFT
    $scope.resetDraft = function () {
        $scope.seachAccount = ''
        $scope.searchCategory = ''
        $scope.managedAccount = undefined
        $scope.chosenManagedAccount = undefined
        $scope.popupImportTemplate = {}
        $scope.simulationResult = undefined
        $scope.prmResult = undefined
        $scope.prmOk = undefined
        return DataAccess.resetVendorDraft().$promise.then((draft) => {
            $scope.draft = draft.toJSON()
            $scope.desired_mes_date = $scope.draft.desired_mes_date ? moment($scope.draft.desired_mes_date).format('DDMMYYYY') : $scope.desired_mes_date
            $scope.updateDateTemplate()
        })
        .catch(ErrorCatcher)
    }

    $scope.resetDraft()

    // PRM
    $scope.fetchPrm = function () {
        $scope.prmChanged()
        $scope.fetching = true
        $scope.prmOk = false
        return ApiUser.eligibilityPRM({ id_prm: $scope.draft.id_prm, id_contract: $scope.draft.id, pro: true }).$promise.then((prm) => {
            $scope.prmResult = prm.toJSON()
            if (prm.eligible) {
                if (prm.duplicates) {
                    $scope.prmResult.message = `Le point que vous essayez d'ajouter est déjà` +
                        ` dans le périmètre de ${prm.duplicates[0].owner} au status "${$filter('contractStatus')(prm.duplicates[0].status)}"`
                }
                $scope.prmOk = true
                $scope.isC5 = !prm.segment || prm.segment === 'C5' || prm.segment === 'INDET'
                $scope.plan_id = prm.plan != null ? prm.plan.id : undefined
                $scope.id_p_calendar = prm.plan != null ? prm.plan.id_p_calendar : undefined
                $scope.draft.plan_id = prm.plan != null ? prm.plan.id : undefined
                $scope.draft.id_p_calendar = prm.plan != null ? prm.plan.id_p_calendar : undefined
                $scope.draft.plan = prm.plan != null ? prm.plan.label : undefined
                $scope.draft.meter_kind = prm.metter.kind
                $scope.draft.routing_tariff = prm.routing_tariff
                $scope.draft.max_power = prm.power != null ? prm.power.max : undefined
                $scope.draft.power_unit = prm.power != null ? prm.power.unit : undefined
                $scope.draft.addr_city_code = prm.addr.city_code
                $scope.draft.addr_city_lbl = prm.addr.city_lbl
                $scope.draft.addr_details = prm.addr.details
                $scope.draft.addr_num_street = prm.addr.num_street
                $scope.draft.addr_post_code = prm.addr.post_code
                $scope.draft.choosen_plan_id = null
                $scope.draft.choosen_max_power = null
                $scope.draft.choosen_id_p_calendar = null
                $scope.draft.chosen_phase = null
                $scope.draft.prm_category = prm.prm_category
            }
        }).catch((error) => {
            $scope.prmResult = error
            $scope.prmOk = false
            ErrorCatcher(error)
        }).finally(() => {
            $scope.fetching = false
        })
    }

    $scope.prmChanged = function () {
        $scope.prmResult = undefined
        $scope.prmOk = false
    }

    // PRM SEARCH
    $scope.searchPrm = () =>
        ModalService.openModal({ type: 'prmSearchModal', size: 'xlg' }, { light: false }, (result) => {
            $scope.draft.id_prm = result
            if ($scope.draft.id_prm.length === 14) {
                return $scope.fetchPrm()
            }
        })

    // AFFECTED ACCOUNTS
    DataAccess.myAffectations().$promise.then((affectations) => {
        $scope.affectedAccounts = affectations
        if ($stateParams.id_account) {
            $scope.managedAccount = _.find($scope.affectedAccounts, { id_account: $stateParams.id_account })
            $scope.chooseManagedAccount()
        }
    }).catch(ErrorCatcher)

    // CATEGORIES
    $scope.refresh = () => {
        $scope.refreshingCategories = true
        return DataAccess.getRefContractCategories({ id_account: $scope.chosenManagedAccount.id_account, energy_type: 'ELEC' }).$promise.then((categories) => {
            $scope.categories = categories
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingCategories = false
        })
    }

    // TRANSFORM
    $scope.generateRecap = function () {
        const label = `${$scope.handleServiceOrder ? `Demandeur : <b>${$scope.requester.civ} ${$scope.requester.givenname} ${$scope.requester.sn}</b><br>` : ''}` +
            `Compte : <b>${$scope.chosenManagedAccount.name}</b><br>` +
            `Regroupement : <b>${_.find($scope.categories, { id: $scope.draft.id_category }).name}</b><br>` +
            `PDL : <b>${$scope.draft.id_prm}</b><br>` +
            `Type : <b>${$scope.draft.prm_category}</b><br>` +
            `Adresse : <b>${$scope.draft.addr_num_street}</b><br>` +
            `CP : <b>${$scope.draft.addr_post_code}</b><br>` +
            `Libellé : <b>${$scope.draft.label || '- Pas de libellé -'}</b><br>` +
            `Date MES : <b>${moment($scope.draft.desired_mes_date).format('DD MMM YYYY')}</b><br>` +
            `Contact : <b>${$scope.contact.civ} ${$scope.contact.givenname} ${$scope.contact.sn}</b><br>` +
            `<b>(${$scope.contact.phone})</b><br>` +
            `<b>${$scope.contact.email}</b><br>`
        $scope.recap = {
            expl: {
                label,
                type: 'label',
            },
        }
    }

    $scope.canAddPdl = () => {
        return !!($scope.draft.max_power || $scope.draft.choosen_max_power) &&
            (!$scope.isC5 || !!($scope.draft.id_p_calendar || $scope.draft.choosen_id_p_calendar)) &&
            !!$scope.draft.id_category &&
            !!$scope.contact.civ &&
            !!$scope.contact.givenname &&
            !!$scope.contact.sn &&
            !!$scope.contact.phone &&
            !!$scope.contact.email &&
            !!$scope.draft.prm_category &&
            !!$scope.draft.label &&
            (!$scope.handleServiceOrder || (
                !!$scope.requester.civ &&
                !!$scope.requester.givenname &&
                !!$scope.requester.sn
            ))
    }

    $scope.openNewCategoryModal = () => {
        ModalService.openModal({ type: 'editCategoryModal', size: 'xlg', backdrop: 'static' }, { category: null, id_account: $scope.chosenManagedAccount.id_account },
            (result) => {
                $scope.refresh().then(() => {
                    if (result) {
                        $scope.selectCategory({ id: result })
                    }
                })
            })
    }

    $scope.addPdl = function () {
        let ok = false
        const payload = {
            technicalContact: $scope.contact,
            requester: $scope.requester,
        }
        $scope.addingPdl = true
        const draftPayload = {
            id_category: $scope.draft.id_category,
            label: $scope.draft.label,
            desired_mes_date: moment($scope.draft.desired_mes_date).format('YYYY-MM-DD'),
            bypass_retractation: true,
            choosen_max_power: $scope.draft.choosen_max_power,
            choosen_id_p_calendar: $scope.draft.choosen_id_p_calendar,
            chosen_phase: $scope.draft.chosen_phase,
            prm_category: $scope.draft.prm_category,
            choosen_routing_tariff: $scope.draft.choosen_routing_tariff,
        }
        return DataAccess.updateProDraft({ id: $scope.draft.id }, draftPayload).$promise
        .then(() =>
            ApiUser.changeDraftOwner({ idDraft: $scope.draft.id, idAccount: $scope.chosenManagedAccount.id_account, transform: true }, payload).$promise.then(() => {
                AlertManager.success('PDL ajouté avec succès')
                ok = true
            }))
        .catch(ErrorCatcher)
        .then(() => {
            // stupid trick to avoid "transition prevented"
            if (ok) {
                return $state.go('pdls', { prm: $scope.draft.id_prm, activate: true })
            }
        })
        .finally(() => {
            $scope.addingPdl = false
        })
    }
})
